import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'


@Injectable()
export class ImageUtils {

  constructor(private sanitizer: DomSanitizer) {}

  private isURL(str): boolean {
    var expr = /(((https?:\/\/)|(www\.))[^\s]+)/g;

    return expr.test(str);
  }

  /**
   * Check whether img.value is an URL or base64, and return appropriate
   * img src value.
   */
  getSrc(img): any {

    if (img && img.value) {
      if (this.isURL(img.value)) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(img.value);
      } else {
        return `data:${img.filetype};base64,${img.value}`;
      }
    } else {
      return "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/imageutils.ts